import postReplyEvents from "../../functions/replies";

/* ==================================================================
 *  people_mypage/replies#show PC、SP共通
 * ================================================================== */
// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.people_mypage.replies.show").length) return;
  postReplyEvents();
});
